import { Link } from "react-router-dom";
import { AlertTriangle, ArrowLeft, Search } from "lucide-react";
import PageHero from "../components/PageHero";
import { useSEO } from "../lib/seo";
import { ASSETS, SITE } from "../lib/site";

export default function NotFound() {
  useSEO({
    title: "Halaman Tidak Ditemukan | Sloto69",
    description: "Halaman yang Anda cari tidak ditemukan. Kembali ke halaman utama atau baca artikel Sloto69.",
    canonical: `${SITE.baseUrl}/404`,
    image: `${SITE.baseUrl}${ASSETS.ogImage}`,
    robots: "noindex, follow",
  });

  return (
    <>
      <PageHero
        eyebrow="404"
        title="Halaman Tidak Ditemukan"
        description="Alamat yang Anda buka tidak tersedia atau sudah berubah. Pilih halaman berikut untuk melanjutkan."
        breadcrumb={[{ label: "404" }]}
      />
      <section className="section-pad">
        <div className="shell">
          <div className="card-premium p-6 sm:p-8 text-center max-w-2xl mx-auto">
            <AlertTriangle className="mx-auto h-10 w-10 text-[#D4AF37]" />
            <h2 className="mt-4 font-display text-2xl font-semibold">Mari kembali ke jalur resmi</h2>
            <p className="mt-3 text-sm text-slate-400">
              Anda bisa kembali ke beranda atau mencari panduan yang sesuai di halaman artikel.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Link to="/" className="btn-primary">
                <ArrowLeft className="h-4 w-4" /> Beranda
              </Link>
              <Link to="/artikel" className="btn-secondary">
                <Search className="h-4 w-4" /> Cari Artikel
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
